//@flow
import _ from 'lodash';
import Shape from './Shape';
import Font from './Font';
import { PLACEHOLDER_TEXT, renderText } from '../live-draw/svg/Text';

export default class Text extends Shape {
  constructor(x, y, width, height, id) {
    super(x, y, width, height, id);
    this.text = PLACEHOLDER_TEXT;
    this.active = true;
    this.font = new Font();
  }

  static createWithDefaults(scale) {
    const x = 10 / scale;
    const y = 10 / scale;
    const width = 100 / scale;
    const height = 100 / scale;
    return new Text(x, y, width, height);
  }

  /**
   * Returns an svg string with the given text elements.
   *
   * @param {Array.<Text>} textArray
   * @param {Number} width
   * @param {Number} height
   */
  static getSvg(textArray, width, height, fontSize) {
    const textSvg = textArray.map((text) => {
      // const div = document.createElement('div');
      // await new Promise(resolve => ReactDOM.render(renderText(text.toSvgRect(1)), div, resolve));
      // return div.innerHTML;

      const { fontFamily, fontSize, fontColor, isBold, isItalic, isUnderline } = text.font;

      let style = [`font-family: '${fontFamily}'`, `font-size: ${fontSize}px`, `color: ${fontColor}`];

      if (isBold) style.push(`font-weight: 600`);
      if (isItalic) style.push(`font-style: italic`);
      if (isUnderline) style.push(`text-decoration: underline`);

      const attrs = [
        `x="${Math.round(text.x)}"`,
        `y="${Math.round(text.y + fontSize)}"`,
        `width="${Math.round(text.width)}"`,
        `height="${Math.round(text.height)}"`,
        `fill="${fontColor}"`,
        `style="${style.join('; ')}"`
      ];
      return `<text ${attrs.join(' ')}>${Text.textFormat(text.x, text.text)}</text>`;
      //return `<text ${attrs.join(' ')}>${text.text}</text>`;
    });

    // const textSvg = await Promise.all(promises);
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox= "0 0 ${width} ${height}">${textSvg.join(
      ''
    )}</svg>`;
  }

  toSvgRect(scale) {
    const scaledFont = _.cloneDeep(this.font);
    scaledFont.fontSize *= scale;
    return {
      ...super.toSvgRect(scale),
      font: scaledFont,
      text: this.text
    };
  }

  static tspanAbleText(x: number, text: string) {
    return '<tspan x="' + x + '" style="white-space: pre;" xml:space="preserve" dy="1.2em">' + text + '</tspan>';
  }

  static textFormat(x: number, text: string) {
    let textArray = text.split('\n');
    let appendTspanString = '';
    for (let i = 0; i < textArray.length; i++) {
      if (!textArray[i].length) {
        appendTspanString = appendTspanString + Text.tspanAbleText(x, ' ');
      } else if (i != 0) {
        appendTspanString = appendTspanString + Text.tspanAbleText(x, textArray[i]);
      } else {
        appendTspanString = textArray[i];
      }
    }
    return appendTspanString;
  }
}
